const handleChartYAxesOptions = (attr) => {
  switch (attr.title) {
    case 'Presence': {
      return {
        type: 'linear',
        display: true,
        position: 'left',
        offset: true,
        gridLines: {
          drawTicks: false,
          drawBorder: false,
        },
        ticks: {
          padding: 10,
          beginAtZero: true,
          max: 1,
          min: 0,
          stepSize: 1,
          callback: function (value) {
            if (value === 1) {
              return 'Yes';
            } else if (value === 0) {
              return 'No';
            } else {
              return '';
            }
          },
        },
      };
    }
  }
};

export default handleChartYAxesOptions;
